'use strict';

export class ImplantsRecordDetailDialogModel {
  constructor(data) {    
    this.data = angular.copy(data);

    this.modalService = null;
    this.scope = null;

    this.leftImplants = this.data.Left;
    this.rightImplants = this.data.Right;

    [this.leftImplants, this.rightImplants].forEach(config => {
      config.forEach((object) => {
        if (object.Option === 'N') {
          object.clearOthers = true;
        }

        if (object.Option === 'I') {
          object.typeSpecified = false;
        }

        if (['S', 'G', 'D', 'A'].indexOf(object.Option) !== -1) {
          object.typeSpecified = true;
        }


        if (['P', 'R'].indexOf(object.Option) !== -1) {
          object.combined = true;
        }
      });
    });
    this.dataCopy = angular.copy(data);
    this.dataCopy.Left = angular.copy(this.leftImplants);
    this.dataCopy.Right = angular.copy(this.rightImplants);
  }

  init(modal, scope, modalService) {
    this.scope = scope;
    this.modalInstance = modal;
    this.modalService = modalService;
  }

  hasImplant(implantItem) {
    return !!implantItem.Value;
  }

  _toggleImplant(implantItem, breastSideCollection) {

    if (implantItem.Value) {
      implantItem.Value = "";
    } else {
      implantItem.Value = implantItem.Option;

      breastSideCollection.forEach(item => {
        if (implantItem.clearOthers) {
          if (item !== implantItem) {
            item.Value = '';
          }
        } else {
          if (item.Option === 'N') {
            item.Value = '';
          }
        }

        if (implantItem.typeSpecified) {
          if (item.Option === "I")
            item.Value = '';
        } else if (!implantItem.combined) {
          if (['S', 'G', 'D', 'A'].indexOf(item.Option) !== -1) {
            item.Value = '';
          }
        }
      });
    }

    return breastSideCollection;
  }

  toggleRightImplant(implantItem) {
    this._toggleImplant(implantItem, this.rightImplants);
  }

  toggleLeftImplant(implantItem) {
    this._toggleImplant(implantItem, this.leftImplants);
  }

  toggleBothSide() {
    if (this.data.SameInBoth === 'True') {
      this.data.SameInBoth = 'False';
    } else {
      this.data.SameInBoth = 'True';
    }
  }

  _hasChanged() {
    var difference = [];
    for(let i = 0; i < this.data.Left.length ; i++){
      for (var property in this.data.Left[i]) {            
        if(this.dataCopy.Left[i][property] !== this.data.Left[i][property]){
          difference.push(property);
        }
      } 
    }
    difference = [];
    for (var property in this.data) {            
      if(this.dataCopy[property] !== this.data[property]){
        difference.push(property);
      }
    } 
    return !angular.equals(this.dataCopy, this.data);
  }

  save() {
    if (this.data.SameInBoth === 'True') {
      let leftImplants = this.data.Left;
      this.data.Right.forEach((rightOption) => {
        leftImplants.forEach((leftOption) => {
          if (leftOption.Option === rightOption.Option) {
            leftOption.Value = rightOption.Value;
          }
        });
      });
      this.data.Left = leftImplants;
    }else{
      let leftImplantSelected = this.data.Left.filter((implantOption) => implantOption.Value)
        .map(this.getImplantLabelValue);
      let rightImplantSelected = this.data.Right.filter((implantOption) => implantOption.Value)
        .map(this.getImplantLabelValue);
      if(angular.equals(leftImplantSelected, rightImplantSelected)){
        this.data.SameInBoth = 'True';
      }      
    }

    this.dataCopy = _.cloneDeep(this.data);
    this.modalInstance.remove();
  }

  getImplantLabelValue = function (implant) {
    return implant.Label || implant.Lable;
  };

  async closeWindow() {
    if (this._hasChanged()) {      
      const confirmed = await this.modalService.showConfirmation(null, 'You have unsaved changes. Are you sure you want to cancel?')
      if (confirmed) {
        this.cancelled = true;
        this.modalInstance.remove();
      }
      return;
    }
    this.cancelled = true;
    this.modalInstance.remove();
  };

  close() {
    this.cancelled = true;
    this.modalInstance.remove();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/models/implantsRecordDetails.js